import { getFirebase } from "react-redux-firebase";
import fbConfig from '../../config/secondaryAuth'

export const signIn = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        dispatch({
          type: "LOGIN_SUCCESS",
        });
      })
      .catch((err) => {
        dispatch({
          type: "LOGIN_ERROR",
          err,
        });
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({
          type: "SIGNOUT_SUCCESS",
        });
      })
      .catch((err) => {
        dispatch({
          type: "SIGNOUT_ERROR",
          err,
        });
      });
  };
};

export const signUp = (newUser) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    const firestore = getFirestore();
    const firebase = getFirebase();
    firebase
      .auth()
      .createUserWithEmailAndPassword(newUser.email, newUser.password)
      .then((resp) => {
        return firestore.collection("users").doc(resp.user.uid).set({
          unit:newUser.unit,
          name: newUser.unit,
          userType:'unit'
        })
      })
      
      .then(() => {
        dispatch(
          {type: 'SIGNUP_SUCCESS'}
        )
        firebase
          .auth()
          .signOut()
      })
      
      .catch((err) => {
        dispatch({
          type: "SIGNUP_ERROR",
          err,
        });
      });
  };
};
